
import { base_url } from "./constants";
import axios from 'axios';

import imageCompression from 'browser-image-compression';


const axiosInstance = axios.create({
    baseURL: base_url
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('UserAuthToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);



axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('UserAuthToken');
            localStorage.removeItem('UserAuthTokenExpiry');
            window.location.reload()
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);



// AUTHENTICATION
export const AdminLogin = async (loginId, password) => {
    return await axios.post(`${base_url}/Authentication/Authenticate`, {
        loginId: loginId.trim(),
        password: password
    });
};

export const ForgotPassword = async (loginId) => {
    return await axios.get(`${base_url}/Authentication/Forgot?loginId=${loginId}`);
};

export const ResetPassword = async (data) => {
    return await axios.post(`${base_url}/Authentication/Forgot`, data);
};


export const GetUsers = async () => {
    return await axiosInstance.get(`${base_url}/Authentication/GetUsers`);
};

export const SignUpUser = async (data) => {
    return await axiosInstance.post(`${base_url}/Authentication/SignUpUser`, data);
};


export const GetUserProfile = async (loginId) => {
    return await axiosInstance.get(`${base_url}/Authentication/GetProfile?loginId=${loginId}`);
};

export const ChangeUserPassword = async (data) => {
    return await axiosInstance.post(`${base_url}/Authentication/ChangePassword`, data);
};





export const GetDownloads = async (type) => {
    return await axiosInstance.get(`${base_url}/Core/Downloads?type=${type}`);
};




export const GetHomeSliders = async (type) => {
    return await axiosInstance.get(`${base_url}/Core/GalleryByType?type=${type}`);
};
export const PostHomeSliders = async (data) => {
    return await axiosInstance.post(`${base_url}/Core/Gallery`, data);
};


export const PostDownloads = async (data) => {
    return await axiosInstance.post(`${base_url}/Core/Downloads`, data);
};



export const GetDownloadCategories = async () => {
    return await axiosInstance.get(`${base_url}/Core/Categories`);
};
export const PostDownloadCategory = async (data) => {
    return await axiosInstance.post(`${base_url}/Core/Categories`, data);
};


export const GetSettings = async () => {
    return await axiosInstance.get(`${base_url}/Core/Settings`);
}

export const GetPages = async () => {
    return await axiosInstance.get(`${base_url}/Core/Pages`);
}

export const GetPageByName = async (pName) => {
    return await axiosInstance.get(`${base_url}/Core/PageByName?name=${pName}`);
}


export const GetPageByType = async (type) => {
    return await axiosInstance.get(`${base_url}/Core/PagesByType?type=${type}`);
};

export const PostPage = async (data) => {
    return await axiosInstance.post(`${base_url}/Core/Pages`, data);
}

export const PostSettings = async (data) => {
    return await axiosInstance.post(`${base_url}/Core/Settings`, data);
}


const compressImage = async (imageFile) => {
    const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
    };
    try {
        const compressedImage = await imageCompression(imageFile, options);
        return compressedImage;
    } catch (error) {
        console.error('Error compressing image:', error);
        throw error;
    }
};


export const UploadFile = async (data) => {
    const file = data.get('file');
    const fileSizeInMB = file.size / 1024 / 1024;

    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (fileSizeInMB > 2) {
        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png' || fileExtension === 'gif') {
            const compressedImage = await compressImage(file);
            const newData = new FormData();
            newData.append('file', new File([compressedImage], file.name, { type: file.type }));

            return await axiosInstance.post(`${base_url}/Core/UploadFile`, newData);

        }
        else {
            return await axiosInstance.post(`${base_url}/Core/UploadFile`, data);
        }
    }
    else {
        return await axiosInstance.post(`${base_url}/Core/UploadFile`, data);
    }
}



export const DeleteGallery = async (id) => {
    return await axiosInstance.post(`${base_url}/Core/DeleteGallery?id=${id}`);
}

export const DeleteCategory = async (id) => {
    return await axiosInstance.post(`${base_url}/Core/DeleteCategory?id=${id}`);
}

export const DeletePage = async (id) => {
    return await axiosInstance.post(`${base_url}/Core/DeletePage?id=${id}`);
}

export const DeleteDownloads = async (id) => {
    return await axiosInstance.post(`${base_url}/Core/DeleteDownload?id=${id}`);
}












// export const GetFile = async (path) => {
//     try {
//         const response = await axios.get(`${base_url}/Site/GetImage?path=${path}`, {
//             responseType: 'blob'
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Error fetching file:", error);
//         throw error;
//     }
// };
// export const fetchLogo = async (path, setLogoUrl) => {
//     try {
//         const fileBlob = await GetFile(path);
//         const contentType = fileBlob['type'];
//         const fileUrl = URL.createObjectURL(fileBlob);
//         if (contentType && contentType.startsWith('image/')) {
//             setLogoUrl({ type: 'image', file: fileUrl });
//         }
//         else if (contentType && contentType.startsWith('video/')) {
//             setLogoUrl({ type: 'video', file: fileUrl });
//         }
//         else {
//             setLogoUrl({ type: 'file', file: fileUrl });
//         }
//     } catch (error) {
//         console.error('Error fetching logo:', error);
//     }
// };